import { useCallback } from 'react'
const uoms = {
  '23': 'g/cm3',
  '28': 'kg/m2',
  '2J': 'cm3/s',
  '2M': 'cm/s',
  '2X': 'm/min',
  '2Z': 'mV',
  '4G': 'µl',
  '4H': 'µm',
  '4K': 'mA',
  '4O': 'µF',
  '4T': 'pF',
  '59': 'ppm',
  A: 'Ampoule',
  A87: 'GOhm',
  A93: 'g/m3',
  A97: 'hPa',
  AMP: 'A',
  ANN: 'Year',
  B0: 'Btu/ft3',
  B11: 'J/(kg*K)',
  B22: 'kA',
  B34: 'kg/dm3',
  B45: 'kmol',
  B47: 'ND',
  B49: 'kOhm',
  B73: 'MN',
  B75: 'MOhm',
  B78: 'MV',
  B84: 'µA',
  B98: 'µs',
  BA: 'Bale',
  BAR: 'bar',
  BB: 'BulkBag',
  BG: 'Bag',
  BIB: 'Bag in Box',
  BIN: 'Bin',
  BLK: 'Bulk',
  BO: 'Bottle',
  BOX: 'Box',
  BRL: 'Barrel',
  BUC: 'Bucket',
  BX: 'Crate',
  C10: 'mF',
  C15: 'mJ',
  C16: 'mm/s',
  C18: 'mmol',
  C19: 'mol/kg',
  C24: 'mPa.s',
  C26: 'ms',
  C29: 'mT',
  C31: 'mW',
  C34: 'mol',
  C36: 'Mol/m3',
  C38: 'Mol/Liter',
  C39: 'nA',
  C41: 'nF',
  C45: 'nm',
  C47: 'ns',
  C56: 'N/mm2',
  C60: 'Ohm*cm',
  C61: 'Ohm*m',
  C62: 'Activ.unit',
  C65: 'Pascal sec',
  CA: 'Canister',
  CAP: 'Capsules',
  CBY: 'Carboy',
  CDL: 'cd',
  CEL: '°C',
  CMK: 'cm2',
  CMQ: 'cm3',
  CMT: 'cm',
  CNT: 'Container',
  CS: 'Case',
  CT: 'Carton',
  CX: 'Coil',
  CYL: 'Cylinder',
  D10: 'Siemens/m',
  D33: 'D',
  D41: 't/m3',
  D46: 'VA',
  D53: 'W/(m*K)',
  D87: 'mmol/kg',
  DAY: 'Days',
  DD: 'Degree',
  DMQ: 'Cubic dec.',
  DMT: 'dm',
  DR: 'Drum',
  DZN: 'Dozen',
  EA: 'each',
  FAH: '°F',
  FAR: 'F',
  GE: 'lb/gal',
  GL: 'g/l',
  GLL: 'US gallon',
  GP: 'mg/m3',
  GQ: 'µg/m3',
  GRM: 'g',
  GRO: 'Gross',
  HLT: 'hl',
  HTZ: 'Hz',
  HUR: 'Hours',
  IBC: 'IBC',
  IE: 'Persons',
  INH: 'Inches',
  IST: 'Isotank',
  JAR: 'Jar',
  JC: 'Jerrycan',
  JOU: 'J',
  JUG: 'Jug',
  KEL: 'K',
  KGM: 'kg',
  KGS: 'kg/s',
  KHZ: 'kHz',
  KJO: 'kJ',
  KMH: 'km/h',
  KMQ: 'kg/m3',
  KMT: 'km',
  KPA: 'kPa',
  KVA: 'kVA',
  KVT: 'kV',
  KWH: 'kwh',
  KWT: 'KW',
  L2: 'l/min',
  LBR: 'Pound',
  LTR: 'l',
  M1: 'mg/l',
  MAW: 'MW',
  MBR: 'mbar',
  MGM: 'mg',
  MHZ: 'MHz',
  MIL: 'Thousands',
  MIN: 'min.',
  MLT: 'ml',
  MMK: 'mm2',
  MMQ: 'mm3',
  MMT: 'mm',
  MON: 'Months',
  MPA: 'MPa',
  MQH: 'm3/h',
  MQS: 'm3/s',
  MSK: 'm/s2',
  MTK: 'm2',
  MTQ: 'm3',
  MTR: 'm',
  MTS: 'm/s',
  MVA: 'MVA',
  NEW: 'N',
  OCT: 'Octabin',
  OHM: 'Ohm',
  P1: '%',
  PAI: 'Pail',
  PAL: 'Pa',
  PCE: 'Piece',
  PCH: 'Pouch',
  PF: 'Pallet',
  PK: 'Pack',
  PR: 'Pair',
  PSZ: 'Pack Size',
  QT: 'Quart US l',
  RO: 'Roll',
  S4: 'm2/s',
  SAC: 'Sack',
  SCH: 'Sachet',
  SEC: 's',
  SMI: 'Mile',
  ST: 'Set',
  STN: 'US ton',
  STP: 'Strips',
  TB: 'Tube',
  TET: 'Tests',
  TIN: 'Tin',
  TNE: 't',
  TNK: 'Tank',
  TOT: 'Tote',
  U2: 'Tablet',
  UN: 'Unit',
  VIA: 'Vial',
  VLT: 'V',
  WEE: 'Weeks',
  WTT: 'W',
  YRD: 'Yards',
} as const

export type UoM = typeof uoms
export type UFn = (
  uom: keyof UoM | string | undefined,
) => UoM[keyof UoM] | string
export const useUom = (): UFn =>
  useCallback<UFn>(uom => (uom && uoms[uom as keyof UoM]) ?? uom ?? '', [])
